import { useUserContext } from '../../context/user.context';
import { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from '../../Helper/Api/axios.instance';
import { AppConfig } from '../../Config/app-config';
import { ReferralInviteType } from '../../types/referralInvite.type';
import { toast } from 'react-toastify';
import { ExceptionsMap } from '../../utils/exceptionsMap';

export const useReferral = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { isLoggedIn, profileData } = useUserContext();
  const [referralInvites, setReferralInvites] = useState<ReferralInviteType[]>(
    [],
  );

  useEffect(() => {
    if (profileData?.referralCode && isLoggedIn) {
      void fetchMyInvites();
    } else {
      setReferralInvites([]);
      setIsLoading(false);
    }
  }, [profileData, isLoggedIn]);

  const fetchMyInvites = useCallback(async () => {
    setIsLoading(true);

    try {
      const { data } = await axiosInstance.get<ReferralInviteType[]>(
        AppConfig.apiRoutes.getReferralInvites(),
      );

      setReferralInvites(data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const redeemReferralCode = useCallback(async (code: string) => {
    setIsLoading(true);

    try {
      const {
        status,
        data,
      } = await axiosInstance.post(
        AppConfig.apiRoutes.redeemReferralCode(),
        {
          code,
        },
      );

      if (status >= 400) {
        toast.error(ExceptionsMap[data.message] || data.message);
        return false;
      }

      if (data.success) {
        toast.success('Referral Code Redeemed Successfully');
        return true;
      }

      return false;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    isLoading,
    referralInvites,
    referralCode: profileData.referralCode,
    redeemReferralCode,
  };
};
